import React, { forwardRef, useMemo } from 'react'
import { Uniform } from 'three'
import { Effect, BlendFunction } from 'postprocessing'

const fragmentShader = `

void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {

	vec3 color = vec3(1.0)-inputColor.rgb*1.0;

	outputColor = vec4(color, inputColor.a);

}`


// Effect implementation
class ReverseEffect extends Effect {
  constructor(blendFunction = BlendFunction.NORMAL) {
    super('MyCustomEffect', fragmentShader, {blendFunction})

  }

  update(renderer, inputBuffer, deltaTime) {
      
  }
}

// Effect component
export const Reverse = forwardRef(({ param }, ref) => {
  const effect = useMemo(() => new ReverseEffect(param), [param])
  return <primitive ref={ref} object={effect} dispose={null} />
})